import { WalletPage } from '@hero/web-components';

export function WalletPageContainer() {
  return <WalletPage displayForUser="carrier" />;
}
